import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { fgStockTransferReq } from 'apps/services/warehouse-service/src/app/fg-stock-transfer/fg-stock-transfer-request';
import { FgStockTransferService } from './fg-stock-transfer.service';


@ApiTags('fg-stock-transfer')
@Controller('fg-stock-transfer')
export class FgStockTransferController {
    constructor(
      private FgStockTransferService: FgStockTransferService,
      private readonly applicationExceptionhandler: ApplicationExceptionHandler,
  
    ) { }

    @Post('/gettransferTypeData')
  async gettransferTypeData(@Body() req?:fgStockTransferReq): Promise<CommonResponse> {
    try {
      return await this.FgStockTransferService.gettransferTypeData(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getFgWarehouseTransferStatus')
  async getFgWarehouseTransferStatus(): Promise<CommonResponse>{
    try{
      return await this.FgStockTransferService.getFgWarehouseTransferStatus();
    }catch(error){
      return this.applicationExceptionhandler.returnException(CommonResponse,error);
    }
  }
}
